import { IManifestContextBuilder } from '@wix/editor-platform-manifest-services';
import { EditorReactComponent } from '@wix/component-protocol/schema';
import { CompRef } from '@wix/document-services-types';
import { EditorPointer } from '@wix/editorx-core-api';

type ManifestNamespace = 'data' | 'cssProperties' | 'cssCustomProperties';

export const createContextBuilder =
  (
    editorPointer: EditorPointer<CompRef>,
    namespace: ManifestNamespace,
    itemsKeys?: string[],
  ): IManifestContextBuilder =>
  (builder) => {
    builder.byEditorPointer(editorPointer, (manifest) => {
      if (!manifest) {
        return;
      }
      if (!itemsKeys || itemsKeys.length === 0) {
        builder.withManifest(editorPointer, manifest);
        return;
      }
      const subManifest = itemsKeys.reduce((acc, key) => {
        if (manifest[namespace]?.[key]) {
          acc[key] = manifest[namespace][key];
        }
        return acc;
      }, {} as Record<string, any>);

      if (Object.keys(subManifest).length === 0) {
        builder.withManifest(editorPointer, manifest);
        return;
      }

      const updatedManifest: EditorReactComponent = {
        editorElement: {
          ...manifest,
          [namespace]: subManifest,
        },
      };

      builder.withManifest(editorPointer, updatedManifest);
    });
  };
